import { createBrowserRouter, Navigate } from "react-router-dom";

import { RequireAuth } from "./components/RequireAuth";
import LoginPage from "./pages/LoginPage";
import ProfilePage from "./pages/ProfilePage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import VerifyEmailChangePage from "./pages/VerifyEmailChangePage";
import ChatPage from "./pages/ChatPage";
import ChecklistPage from "./pages/ChecklistPage";
import KycPage from "./pages/KycPage";
import TermsPage from "./pages/TermsPage";
import CpfPage from "./pages/CpfPage";
import MarketPage from "./pages/MarketPage";
import CryptoRampPage from "./pages/CryptoRampPage";
import CoinPortfolioPage from "./pages/CoinPortfolioPage";
import TradePage from "./pages/TradePage";
import PortfolioAssetsPage from "./pages/PortfolioAssetsPage";
import OrdersPage from "./pages/OrdersPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import FuturesPositionsPage from "./pages/FuturesPositionsPage";
import FuturesPositionDetailPage from "./pages/FuturesPositionDetailPage";
import DepositPage from "./pages/DepositPage";
import WithdrawPage from "./pages/WithdrawPage";
import WalletHistoryPage from "./pages/WalletHistoryPage";
import DcaiPage from "./pages/DcaiPage";
import ReferralLandingPage from "./pages/ReferralLandingPage";
import ReferralPage from "./pages/ReferralPage";

import "./App.css";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/profile" replace />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    // Landing pública de indicação: /r/{CODIGO} (aceita qualquer caixa)
    path: "/r/:code",
    element: <ReferralLandingPage />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmailPage />,
  },
  {
    path: "/verify-email-change",
    element: <VerifyEmailChangePage />,
  },
  {
    path: "/profile",
    element: (
      <RequireAuth>
        <ProfilePage />
      </RequireAuth>
    ),
  },
  {
    path: "/referral",
    element: (
      <RequireAuth>
        <ReferralPage />
      </RequireAuth>
    ),
  },
  {
    path: "/dcai",
    element: (
      <RequireAuth>
        <DcaiPage />
      </RequireAuth>
    ),
  },
  {
    path: "/chat",
    element: (
      <RequireAuth>
        <ChatPage />
      </RequireAuth>
    ),
  },
  {
    path: "/checklist",
    element: (
      <RequireAuth>
        <ChecklistPage />
      </RequireAuth>
    ),
  },
  {
    path: "/checklist/terms",
    element: (
      <RequireAuth>
        <TermsPage />
      </RequireAuth>
    ),
  },
  {
    path: "/checklist/cpf",
    element: (
      <RequireAuth>
        <CpfPage />
      </RequireAuth>
    ),
  },
  {
    path: "/market",
    element: (
      <RequireAuth>
        <MarketPage />
      </RequireAuth>
    ),
  },
  {
    path: "/crypto-ramp",
    element: (
      <RequireAuth>
        <CryptoRampPage />
      </RequireAuth>
    ),
  },
  {
    path: "/wallet/portfolio/:coin",
    element: (
      <RequireAuth>
        <CoinPortfolioPage />
      </RequireAuth>
    ),
  },
  {
    path: "/trade/:symbol/:orderType",
    element: (
      <RequireAuth>
        <TradePage />
      </RequireAuth>
    ),
  },
  {
    path: "/portfolio/ativos",
    element: (
      <RequireAuth>
        <PortfolioAssetsPage />
      </RequireAuth>
    ),
  },
  {
    path: "/orders",
    element: (
      <RequireAuth>
        <OrdersPage />
      </RequireAuth>
    ),
  },
  {
    path: "/futures",
    element: (
      <RequireAuth>
        <FuturesPositionsPage />
      </RequireAuth>
    ),
  },
  {
    path: "/futures/positions/:orderId",
    element: (
      <RequireAuth>
        <FuturesPositionDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: "/orders/:orderId",
    element: (
      <RequireAuth>
        <OrderDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: "/wallet/history",
    element: (
      <RequireAuth>
        <WalletHistoryPage />
      </RequireAuth>
    ),
  },
  {
    path: "/wallet/history/:historyId",
    element: (
      <RequireAuth>
        <OrderDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: "/wallet/deposit/:coin",
    element: (
      <RequireAuth>
        <DepositPage />
      </RequireAuth>
    ),
  },
  {
    path: "/wallet/withdraw/:coin",
    element: (
      <RequireAuth>
        <WithdrawPage />
      </RequireAuth>
    ),
  },
  {
    path: "/kyc/:levelName",
    element: (
      <RequireAuth>
        <KycPage />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/profile" replace />,
  },
]);
